"use client";

import { AlertTriangle } from "lucide-react";
import Link from "next/link";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="marketing flex min-h-screen items-center justify-center bg-background px-6">
      <div className="surface-elevated w-full max-w-lg rounded-lg p-8 text-center">
        <div
          className="mx-auto mb-5 flex size-12 items-center justify-center rounded-xl bg-destructive/10 text-destructive"
          aria-hidden
        >
          <AlertTriangle className="size-6" />
        </div>
        <h1 className="mb-2 text-3xl">Something went wrong</h1>
        <p className="mb-6 text-base text-muted-foreground">
          The page hit an unexpected error. You can try again, or head back to
          the console.
          {error.digest ? (
            <span className="mt-2 block font-mono text-xs text-muted-foreground/70">
              Reference {error.digest}
            </span>
          ) : null}
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Button variant="premium" onClick={() => reset()}>
            Try again
          </Button>
          <Button variant="outline" asChild>
            <Link href="/console">Back to console</Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
